// src/features/blockedSellersSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {axiosInstance} from "../../../Auth/axiosInstance";
import { AxiosError } from "axios";

// Define the BlockedSellers model
export interface BlockedSellersViewModel {
  id:number;
  name: string;
  createDate: string; // Use ISO string for Date
}

// Fetch Blocked Sellers (all data at once)
export const fetchBlockedSellers = createAsyncThunk(
  "blockedSellers/fetchBlockedSellers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<BlockedSellersViewModel[]>("filters/get-blocked-sellers");
      return response.data; // Assuming `response.data` is an array
    }catch (err) {
        const error = err as AxiosError; // Assert error type
        if (error.response) {
          // Access error.response safely
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue(error.message);
      }
  }
);

export const deleteBlockedSeller = createAsyncThunk(
  "blockedSellers/deleteBlockedSeller",
  async (id: number, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`filters/delete-blocked-seller/${id}`);
      return id; // Return the deleted ID to update the state
    } catch (err) {
      const error = err as AxiosError;
      if (error.response) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);


const blockedSellersSlice = createSlice({
  name: "blockedSellers",
  initialState: {
    data: [] as BlockedSellersViewModel[],
    loading: false,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlockedSellers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlockedSellers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchBlockedSellers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(deleteBlockedSeller.fulfilled, (state, action) => {
        state.data = state.data.filter((Seller) => Seller.id !== action.payload); // Remove the deleted Seller
      });
      ;
  },
});

export default blockedSellersSlice.reducer;
